// The word list. Written for this app rather than copied from the box:
// the printed game's exact 400-word list is CGE's curation, and we don't
// need it - what makes a good Codenames word is well understood (rulebook
// p4-p7's examples): short, concrete, familiar to everyone at a family
// table, and ideally carrying two or three unrelated meanings so clues can
// cut across the grid (BARK the tree / BARK the dog; PITCH the field / the
// throw / the sales talk).
//
// 400 words, screened to be family-friendly and single-word (compound
// words written solid count, rulebook p7). ALL CAPS to match how the
// printed cards shout.

export const WORDS = [
  'ANCHOR', 'ANGEL', 'ANT', 'APPLE', 'ARM', 'ARROW', 'BACON', 'BADGE',
  'BALL', 'BAND', 'BANK', 'BARK', 'BARREL', 'BASE', 'BAT', 'BATTERY',
  'BEACH', 'BEAM', 'BEAN', 'BEAR', 'BEARD', 'BED', 'BEE', 'BELL',
  'BELT', 'BENCH', 'BERRY', 'BILL', 'BISCUIT', 'BLADE', 'BLOCK', 'BOARD',
  'BOLT', 'BOMB', 'BOOK', 'BOOT', 'BOTTLE', 'BOW', 'BOWL', 'BOX',
  'BRAIN', 'BRANCH', 'BRIDGE', 'BRUSH', 'BUCKET', 'BUCKLE', 'BUG', 'BUTTON',
  'CABIN', 'CABLE', 'CAKE', 'CAMP', 'CANDLE', 'CANE', 'CANNON', 'CAP',
  'CAPE', 'CAPTAIN', 'CARD', 'CARROT', 'CASE', 'CASTLE', 'CAT', 'CAVE',
  'CELL', 'CHAIN', 'CHAIR', 'CHALK', 'CHARGE', 'CHECK', 'CHEESE', 'CHEST',
  'CHICKEN', 'CHIP', 'CHURCH', 'CIRCLE', 'CLAM', 'CLAW', 'CLIFF', 'CLOAK',
  'CLOCK', 'CLOUD', 'CLOWN', 'CLUB', 'COACH', 'COAST', 'COAT', 'COIN',
  'COMB', 'COMET', 'COMPASS', 'COOK', 'COPPER', 'CORN', 'COURT', 'COVER',
  'COWBOY', 'CRAB', 'CRANE', 'CROWN', 'CRYSTAL', 'CURRENT', 'CYCLE', 'DANCE',
  'DECK', 'DESK', 'DIAMOND', 'DICE', 'DINOSAUR', 'DISH', 'DOCK', 'DOCTOR',
  'DOG', 'DOLL', 'DOLPHIN', 'DOOR', 'DOUGH', 'DRAGON', 'DRAWER', 'DREAM',
  'DRESS', 'DRILL', 'DROP', 'DRUM', 'DUCK', 'DWARF', 'EAGLE', 'EAR',
  'EGG', 'ELBOW', 'ENGINE', 'EYE', 'FAIR', 'FALL', 'FAN', 'FARM',
  'FEATHER', 'FENCE', 'FIDDLE', 'FIELD', 'FIGURE', 'FILE', 'FILM', 'FIRE',
  'FISH', 'FLAG', 'FLASH', 'FLOOD', 'FLOOR', 'FLUTE', 'FLY', 'FOAM',
  'FOG', 'FOOT', 'FOREST', 'FORK', 'FORT', 'FRAME', 'FROG', 'FROST',
  'GARDEN', 'GAS', 'GATE', 'GHOST', 'GIANT', 'GLASS', 'GLOVE', 'GOAT',
  'GOLD', 'GRACE', 'GRASS', 'GREENHOUSE', 'GUARD', 'GUITAR', 'HAMMER', 'HAND',
  'HARBOR', 'HAT', 'HAWK', 'HEAD', 'HEART', 'HEDGE', 'HELMET', 'HERO',
  'HOLE', 'HOOD', 'HOOK', 'HORN', 'HORSE', 'HORSESHOE', 'HOSE', 'HOTEL',
  'HOUND', 'ICE', 'INK', 'IRON', 'ISLAND', 'IVORY', 'JACK', 'JAM',
  'JAIL', 'JET', 'JOKER', 'JUDGE', 'JUNGLE', 'KEY', 'KID', 'KING',
  'KITE', 'KNIGHT', 'KNOT', 'LADDER', 'LAMP', 'LANTERN', 'LAP', 'LASER',
  'LAVA', 'LAWYER', 'LEAD', 'LEAF', 'LEMON', 'LETTER', 'LIBRARY', 'LIGHT',
  'LIMB', 'LINE', 'LION', 'LOCK', 'LOG', 'LUCK', 'MAGNET', 'MAIL',
  'MAMMOTH', 'MAP', 'MARBLE', 'MARCH', 'MASK', 'MATCH', 'MAZE', 'MEDIC',
  'MERCURY', 'MILL', 'MINE', 'MINT', 'MIRROR', 'MODEL', 'MOLE', 'MONKEY',
  'MOON', 'MOTH', 'MOUNTAIN', 'MOUSE', 'MOUTH', 'MUD', 'MUMMY', 'MUSTARD',
  'NAIL', 'NEEDLE', 'NEST', 'NET', 'NIGHT', 'NINJA', 'NOTE', 'NOVEL',
  'NURSE', 'NUT', 'OAK', 'OCTOPUS', 'OIL', 'OLIVE', 'ONION', 'OPERA',
  'ORANGE', 'ORGAN', 'OWL', 'PADDLE', 'PAGE', 'PAINT', 'PALM', 'PAN',
  'PANTS', 'PAPER', 'PARACHUTE', 'PARK', 'PARROT', 'PASTE', 'PATCH', 'PEACH',
  'PEANUT', 'PEARL', 'PEN', 'PENGUIN', 'PEPPER', 'PIANO', 'PICKLE', 'PIE',
  'PILLOW', 'PILOT', 'PIN', 'PIPE', 'PIRATE', 'PISTOL', 'PIT', 'PITCH',
  'PLANE', 'PLANET', 'PLASTIC', 'PLATE', 'PLOT', 'POCKET', 'POINT', 'POLE',
  'POOL', 'POP', 'PORT', 'POST', 'POT', 'PRESS', 'PRINCESS', 'PUMPKIN',
  'PUPIL', 'PUPPET', 'PYRAMID', 'QUEEN', 'RABBIT', 'RACKET', 'RAIL', 'RAINBOW',
  'RAKE', 'RANCH', 'RAT', 'RAY', 'RECORD', 'REED', 'RING', 'RIVER',
  'ROBIN', 'ROBOT', 'ROCK', 'ROCKET', 'ROOT', 'ROPE', 'ROSE', 'ROUND',
  'ROW', 'RULER', 'SADDLE', 'SAIL', 'SALT', 'SAND', 'SATELLITE', 'SAW',
  'SCALE', 'SCARECROW', 'SCHOOL', 'SCORPION', 'SCREEN', 'SEAL', 'SEED', 'SHADOW',
  'SHARK', 'SHED', 'SHEET', 'SHELL', 'SHIP', 'SHOE', 'SHOP', 'SHOT',
  'SHOWER', 'SIGN', 'SINK', 'SKATE', 'SKULL', 'SLEEVE', 'SLIP', 'SMOKE',
  'SNAIL', 'SNAKE', 'SNOW', 'SOAP', 'SOCK', 'SOLDIER', 'SOUP', 'SPACE',
  'SPELL', 'SPIDER', 'SPINE', 'SPOON', 'SPOT', 'SPRING', 'SPY', 'SQUARE',
  'STABLE', 'STAFF', 'STAGE', 'STAMP', 'STAR', 'STATE', 'STEAM', 'STICK',
  'STOCK', 'STONE', 'STORM', 'STOVE', 'STRAW', 'STREAM', 'STRING', 'SUB',
  'SUGAR', 'SUIT', 'SUN', 'SWAMP', 'SWITCH', 'SWORD', 'TABLE', 'TAIL',
  'TANK', 'TAP', 'TEACHER', 'TELESCOPE', 'TEMPLE', 'THEATER', 'THIEF', 'THORN',
  'THUMB', 'TIDE', 'TIGER', 'TIP', 'TOAST', 'TOOTH', 'TORCH', 'TOWER',
  'TRACK', 'TRAIN', 'TRAP', 'TREE', 'TRIANGLE', 'TRICK', 'TRIP', 'TRUNK',
  'TUNNEL', 'TURKEY', 'TURTLE', 'UMBRELLA', 'UNICORN', 'VAULT', 'VET', 'VOLCANO',
  'WAGON', 'WALL', 'WAND', 'WATCH', 'WAVE', 'WEB', 'WELL', 'WHALE',
  'WHEEL', 'WHIP', 'WHISTLE', 'WINDOW', 'WING', 'WITCH', 'WIZARD', 'WOLF',
  'WORM', 'YARD', 'YARN', 'ZEBRA', 'ZOMBIE', 'ZOO',
];
